export default "__VITE_ASSET__Cu3SODp8__"